import React from 'react';
import Hero from '../components/Hero/Hero';
import HomeAbout from '../components/About/HomeAbout';
import Skills from '../components/Skills/Skills';
import ProjectSlider from '../components/ProjectSlider/ProjectSlider';
import Contact from '../components/Contact/Contact';

const HomePage: React.FC = () => {
  return (
    <>
      <div id="home">
        <Hero />
      </div>
      <HomeAbout />
      <ProjectSlider />
      <Skills limit={6} />
      <Contact />
    </>
  );
};

export default HomePage;
